import {Routes, Route} from 'react-router'
import NoMatch from './NoMatch';
import Layout from './Layout';
import Home from './home/Home';
import Overview from './corporations/Overview';
import Greetings from './corporations/Greetings';
import Certifications from './corporations/Certifications';
import CertificationEditor from './corporations/CertificationEditor';
import CertificationViewer from './corporations/CertificationViewer';
import Location from './corporations/Location';
import Partners from './partners/Partners';
import Business from './solutions/business/Business';
import Inverters from './solutions/inverters/Inverters';
import Modules from './solutions/modules/Modules';
import Monitoring from './solutions/monitoring/Monitoring';
import Optimizers from './solutions/optimizers/Optimizers';
import OnM from './solutions/onm/OnM';
import Repowering from './solutions/repowering/Repowering';
import Projects from './projects/Projects';
import ProjectEditor from './projects/ProjectEditor'
import ProjectViewer from './projects/ProjectViewer';
import Signin from './auth/Signin';

export default function RoutesSetup() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="corporation">
          <Route index element={<Overview/>}/>
          <Route path="greetings" element={<Greetings/>}/>
          <Route path='certifications'>
            <Route index element={<Certifications/>}/>
            <Route path="editor" element={<CertificationEditor/>}>
              <Route path=":id" element={<CertificationEditor/>}/>
            </Route>
            <Route path=":id" element={<CertificationViewer/>}/>
          </Route>
          <Route path='location' element={<Location/>}/>
        </Route>
        <Route path='partners'>
          <Route index element={<Partners/>}/>
          <Route path="partners" element={<Partners/>}/>
        </Route>
        <Route path='solutions'>
          <Route index element={<Business/>}/>
          <Route path='inverters' element={<Inverters/>}/>
          <Route path='modules' element={<Modules/>}/>
          <Route path='monitoring' element={<Monitoring/>}/>
          <Route path="optimizers" element={<Optimizers/>}/>
          <Route path="onm" element={<OnM/>}/>
          <Route path="repowering" element={<Repowering/>}/>
        </Route>
        <Route path="projects">
          <Route index element={<Projects/>}/>
          <Route path="editor" element={<ProjectEditor/>}>
              <Route path=":id" element={<ProjectEditor/>}/>
          </Route>
          <Route path=":id" element={<ProjectViewer/>}/>
        </Route>
        <Route path='signin' element={<Signin/>}/>
        <Route path="*" element={<NoMatch />} />
      </Route>
    </Routes>
  )
}